import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

interface SystemEvent {
	serviceName: string;
	action: 'callback_create' | 'callback_read' | 'callback_update' | 'callback_delete';
}

@Injectable({
	providedIn: 'root',
})
export class MsServiceCoreService {
	private _event: Subject<SystemEvent> = new Subject<SystemEvent>();

	constructor() {}

	callbackAction(): Observable<SystemEvent> {
		return this._event;
	}

	callAction(systemEvent: SystemEvent): void {
		this._event.next(systemEvent);
	}
}
